const KNOWLEDGE_URLS = {
  BREEZE_INTELLIGENCE_CREDITS: 'https://knowledge.hubspot.com/account-management/understand-breeze-intelligence-credits-and-billing',
  HUBSPOT_CREDITS: 'https://knowledge.hubspot.com/account-management/understand-hubspot-credits-and-billing'
};
const PRICING_URLS = {
  HUBSPOT_CREDITS: portalId => `/pricing/${portalId}/hubspot-credits`
};
export { KNOWLEDGE_URLS, PRICING_URLS };